
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/utils/formatters';
import EditPaymentMethodDialog from './EditPaymentMethodDialog';

interface PaymentInformationProps {
  author: any;
}

const PaymentInformation: React.FC<PaymentInformationProps> = ({ author }) => {
  return (
    <Card className="lg:col-span-2">
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle>Payment Information</CardTitle>
          <div className="flex gap-2">
            {author.paymentMethod && (
              <EditPaymentMethodDialog 
                authorId={author.id} 
                paymentMethod={author.paymentMethod}
                isEdit={true}
              />
            )}
            <EditPaymentMethodDialog 
              authorId={author.id}
              isEdit={false}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {author.paymentMethod ? (
          <div className="space-y-4">
            <div>
              <h4 className="text-sm font-medium text-muted-foreground mb-1">Payment Method</h4>
              <p className="font-medium capitalize">{author.paymentMethod.type.replace('_', ' ')}</p>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-muted-foreground mb-1">Payment Threshold</h4>
              <p className="font-medium">{formatCurrency(author.paymentMethod.threshold || 0)}</p>
            </div>
            
            <div>
              <h4 className="text-sm font-medium text-muted-foreground mb-2">Payment Details</h4>
              {author.paymentDetails ? (
                <div className="bg-muted p-4 rounded-md">
                  {author.paymentMethod.type === 'paypal' && (
                    <p><span className="font-medium">PayPal Email:</span> {author.paymentDetails.paypal_email}</p>
                  )}
                  
                  {author.paymentMethod.type === 'bank_transfer_us' && (
                    <>
                      <p><span className="font-medium">Bank Name:</span> {author.paymentDetails.bank_name}</p>
                      <p><span className="font-medium">Account Number:</span> {author.paymentDetails.account_number}</p>
                      <p><span className="font-medium">Routing Number:</span> {author.paymentDetails.routing_number}</p>
                    </>
                  )}
                  
                  {author.paymentMethod.type === 'bank_transfer_international' && (
                    <>
                      <p><span className="font-medium">Bank Name:</span> {author.paymentDetails.bank_name}</p>
                      <p><span className="font-medium">Account Number:</span> {author.paymentDetails.account_number}</p>
                      <p><span className="font-medium">SWIFT Code:</span> {author.paymentDetails.swift}</p>
                      <p><span className="font-medium">Address:</span> {author.paymentDetails.address}</p>
                    </>
                  )}
                  
                  {author.paymentMethod.type === 'check' && (
                    <p><span className="font-medium">Address:</span> {author.paymentDetails.address}</p>
                  )}
                </div>
              ) : (
                <p className="text-muted-foreground">No payment details provided</p>
              )}
            </div>
          </div>
        ) : (
          <p className="text-muted-foreground">No payment method set up</p>
        )}
      </CardContent>
    </Card>
  );
};

export default PaymentInformation;
